export function formatThreshold(value: number | null | undefined): string {
  const v = Number(value);
  if (!Number.isFinite(v)) return "-";
  return (Math.trunc(v * 10000) / 10000).toFixed(4);
}
